import {
  LIST_CLASS_TYPE_REQUEST,
  LIST_CLASS_TYPE_SUCCESS,
  LIST_CLASS_TYPE_ERROR,
  RESET_STATE_ALL_APPLICATION,
  RESET_STATE_REDUX
} from '../../actions';

const INIT_STATE = {
  currentClassTypeList: null,
  loading: false,
  success: '',
  error: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_STATE_ALL_APPLICATION:
      return INIT_STATE;
    case RESET_STATE_REDUX:
      return {
        ...state,
        error: '',
        success: '',
      };
    case LIST_CLASS_TYPE_REQUEST:
      return { ...state, loading: true, error: '' };
    case LIST_CLASS_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        currentClassTypeList: action.payload,
        error: '',
      };
    case LIST_CLASS_TYPE_ERROR:
      return {
        ...state,
        loading: false,
        currentClassTypeList: null,
        error: action.payload.message,
      };
    default:
      return { ...state };
  }
};
